import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { SiteLogo } from '../components/SiteLogo';
import { WeddingVideos } from '../components/thankyou/WeddingVideos';
import { ReviewsWall } from '../components/thankyou/ReviewsWall';
export function ThankYou() {
  useEffect(() => {
    document.title = 'You’re confirmed — Twenty Mile House';
  }, []);
  return <div className="min-h-screen w-full bg-white text-ink" data-id="element-121" data-mp="2toum1fb6nqnv">
      <header className="relative flex items-center justify-center border-b border-ink/10 px-6 py-4" data-id="element-122" data-mp="2xrhijtistzre">
        <SiteLogo size="sm" data-id="element-123" data-mp="32i7ksxvxhmhv" />
        <Link to="/bay-area" className="absolute right-6 font-sans text-[10px] font-medium uppercase tracking-[0.25em] text-ink/60 transition-colors duration-150 hover:text-ink md:right-10" data-id="element-124" data-mp="32hxybka3dxgx">
          Return to site
        </Link>
      </header>

      <main data-id="element-125" data-mp="3hf8ev81ldtji">
        <section className="mx-auto max-w-xl px-6 pt-12 text-center" data-id="element-126" data-mp="3heyldahc9492">
          <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full border border-gold/50 bg-notice" data-id="element-127" data-mp="285w8uqa2pr5a">
            <CheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-128" data-mp="2369sw92v1wss" />
          </span>
          <h1 className="mt-5 font-heading text-2xl font-light uppercase leading-[1.2] tracking-[0.06em] text-logo md:text-[2.2rem]" data-id="element-129" data-mp="1y7gkgv2fkvzh">
            You’re confirmed.
          </h1>
          <p className="mx-auto mt-4 max-w-md font-body text-[15px] leading-relaxed text-ink/70" data-id="element-130" data-mp="1u8hc10hhqh3a">
            Thank you for scheduling a virtual tour with Twenty Mile House! We can’t wait to show
            you the property, go over our packages, and answer your questions.
          </p>
        </section>

        <section className="mx-auto mt-12 max-w-2xl px-6" aria-labelledby="meantime-heading" data-id="element-131" data-mp="2d4z2zfoimcyh">
          <div className="border-y border-ink/10 py-6 text-center" data-id="element-132" data-mp="39mvbli7yktmo">
            <h2 id="meantime-heading" className="font-display text-2xl text-ink" data-id="element-133" data-mp="39o6frj5bg3eb">
              In the meantime, add it to your calendar &amp; <em className="text-gold" data-id="element-134" data-mp="12ymli039n1s6">get inspired</em>
            </h2>
            <p className="mx-auto mt-2 max-w-lg font-body text-[15px] leading-relaxed text-ink/70" data-id="element-135" data-mp="12zegp9syaxhx">
              Take a peek at some of our real weddings and hear from couples who’ve celebrated
              here. Scroll down to explore.
            </p>
          </div>
        </section>

        <div className="mt-16" data-id="element-136" data-mp="y6bnx3vzzs2s">
          <WeddingVideos data-id="element-137" data-mp="k84xg8tdoud5" />
          <ReviewsWall data-id="element-138" data-mp="k7lnpfdvtca7" />
        </div>
      </main>
    </div>;
}